import { BackofficeNavigationLinks } from './BackofficeNavigation';

export function BackofficeSidebar() {
  return (
    <nav
      aria-label="Backoffice navigation"
      className="hidden min-h-[240px] bg-neutral-50 p-6 lg:block lg:border-r lg:border-neutral-200"
    >
      <BackofficeNavigationLinks />
    </nav>
  );
}
